import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer, { IAuthState } from '@app/store/features/auth';
import notificationReducer, {
  INotificationState,
} from '@app/store/features/notification';
import modalNotificationReducer, {
  IModalNotificationState,
} from '@app/store/features/modal-notification';
import workspaceReducer, { IWorkspaceState } from '@features/workspace/store';
import loadingReducer, { ILoadingState } from '@app/store/features/loading';

export type IRootState = ReturnType<typeof store.getState>;
export type IAppDispatch = typeof store.dispatch;

interface IReducer {
  auth: IAuthState;
  notification: INotificationState;
  modal_notification: IModalNotificationState;
  workspace: IWorkspaceState;
  loading: ILoadingState;
}

const reducer = combineReducers<IReducer>({
  auth: authReducer,
  notification: notificationReducer,
  modal_notification: modalNotificationReducer,
  workspace: workspaceReducer,
  loading: loadingReducer,
});

export const store = configureStore({
  reducer,
});
